module.exports = __webpack_public_path__ + "static/media/goa.996d5274.jpg";